import { publicAxios as axios } from '@/framework/router/axios'

const apiQuery = (postdata) => {
  return axios.post('/proc-analysis/query', [], {
    params: postdata
  })
}

const apiTargetList = (postdata) => {
  return axios.post('/proc-analysis/target-list', [], {
    params: postdata
  })
}

const apiTaskTargetList = (postdata) => {
  return axios.post('/task-analysis/target-list', [], {
    params: postdata
  })
}

const apiHisChange = (postdata) => {
  return axios.get('/proc-analysis/his-change', {
    params: postdata
  })
}

const apiTabAuth = () => {
  return axios.get('/proc-analysis/tab-authority')
}

export {
  apiQuery,
  apiTargetList,
  apiHisChange,
  apiTaskTargetList,
  apiTabAuth
}
